/* HORCERY — Testimonials slider arrows (native scroll + snap). */
(function () {
  'use strict';
  function init(section) {
    if (!section || section.__hzInit) return;
    section.__hzInit = true;
    var track = section.querySelector('[data-hz-track]');
    var prev = section.querySelector('[data-hz-prev]');
    var next = section.querySelector('[data-hz-next]');
    if (!track) return;
    var step = function () {
      var c = track.querySelector('.hz-tmn__card');
      var gap = parseFloat(getComputedStyle(track).columnGap || 24) || 24;
      return c ? c.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    section.__hzResize = update;
    update();
  }
  function initAll() { document.querySelectorAll('[data-hz-tmn]').forEach(init); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-tmn]');
    if (el) {
      if (el.__hzResize) window.removeEventListener('resize', el.__hzResize);
      el.__hzInit = false; init(el);
    }
  });
})();
